import {createReducer} from 'redux-act';
import {MENU} from 'constants/actions';

import {OPEN_MENU_ITEMS_TO_OPEN, VisibilityMenuType} from './visibilityMenuType';

/**
 * Set visibility main menu
 * @returns {VisibilityMenuType} The menu's state visible
 */
export const visibilityMenu = createReducer<VisibilityMenuType>(
    {},
    {visible: false, openMenuItem: OPEN_MENU_ITEMS_TO_OPEN.DEFAULT},
).on(
    MENU.SET_VISIBILITY_MENU,
    (state: VisibilityMenuType, payload: VisibilityMenuType): VisibilityMenuType => payload,
);

export default visibilityMenu;
